module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-content-honda.f346bdd7.jpg";